import React from 'react';

import { Image as ImageLibNB } from '@gluestack-ui/themed';

export default function Image({ removeTransition, ...props }) {
  return <ImageLibNB alt="image" {...props} />;
}
